export class OrderService {
  private static readonly STORAGE_KEY = 'lastOrderNumber';

  static async getNextOrderId(): Promise<string> {
    // Recupera o último número usado ou começa do 0
    const lastNumber = localStorage.getItem(this.STORAGE_KEY) || '0';
    const nextNumber = parseInt(lastNumber, 10) + 1;
    
    // Salva o novo número
    localStorage.setItem(this.STORAGE_KEY, nextNumber.toString());
    
    // Formata o número com zeros à esquerda (5 dígitos)
    const formattedNumber = nextNumber.toString().padStart(5, '0');
    
    return `OS-${formattedNumber}`;
  }

  // Remove caracteres especiais e limita o tamanho
  static formatName(name: string, maxLength: number): string {
    return name
      .replace(/[^a-zA-Z0-9]/g, '') // Remove caracteres especiais
      .substring(0, maxLength); // Limita o tamanho
  }

  // Gera o nome completo do arquivo
  static generateFileName(orderId: string, userName: string, fileName: string): string {
    const sanitizedUserName = this.formatName(userName, 10);
    const sanitizedFileName = this.formatName(fileName, 12);

    return `${orderId}-${sanitizedUserName}-${sanitizedFileName}.zip`;
  }
} 